import React, { FC, memo } from 'react';
import { Box, SxProps, Theme } from '@mui/material';

export type ProgressBarProps = {
	color?: string;
	backgroundColor?: string;
	fullWidth?: boolean;
	width?: number;
	sx?: SxProps<Theme>;
};

const animationName = 'SystemProgressBar';

export const ProgressBar: FC<ProgressBarProps> = memo((props) => {
	const { color, backgroundColor, width, fullWidth = false, sx } = props;

	return (
		<Box sx={{ width: fullWidth ? '100%' : `${width}px` }}>
			<Box
				sx={{
					height: '4px',
					backgroundColor: backgroundColor ? backgroundColor : 'rgba(5, 114, 206, 0.2)',
					width: '100%',
					overflow: 'hidden',
				}}
			>
				<Box
					sx={{
						width: '100%',
						height: '100%',
						backgroundColor: color ? color : 'rgb(5, 114, 206)',
						animation: `${animationName} 1s infinite linear`,
						transformOrigin: '0% 50%',
					}}
				></Box>
			</Box>
		</Box>
	);
});
